import { ViewAmostraAtual } from '@models/views/view-amostra-atual.model';
import { AmostraUtinga } from '@models/amostra-utinga.model';
import { CriaAmostrasUtingaDto } from '../../../back/src/amostras-utinga/dto/cria-amostras-utinga.dto';
import { CriaAmostraUtingaSimplesDto } from '../../../back/src/amostras-utinga/dto/cria-amostra-utinga-simples.dto';
import { AlteraSemEnsaioDto } from '../../../back/src/amostras-utinga/dto/altera-sem-ensaio.dto';
import { ListaAcompanhamentoAmostraUtingaQueryDto } from '../../../back/src/amostras-utinga/dto/lista-acompanhamento-amostra-utinga-query.dto';
import axios from 'axios';

const listaProducao = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(`/amostras_utinga/producao`);
  return res.data;
};

const cria = async (
  formData: CriaAmostrasUtingaDto,
): Promise<AmostraUtinga[]> => {
  const res = await axios.post<AmostraUtinga[]>(`/amostras_utinga`, formData);
  return res.data;
};

const criaSimples = async (
  criaAmostraUtingaSimplesDto: CriaAmostraUtingaSimplesDto,
): Promise<AmostraUtinga> => {
  const res = await axios.post<AmostraUtinga>(
    '/amostras_utinga/simples',
    criaAmostraUtingaSimplesDto,
  );
  return res.data;
};

const listaAcompanhamento = async (
  queryDto: ListaAcompanhamentoAmostraUtingaQueryDto,
): Promise<{
  count: number;
  rows: ViewAmostraAtual[];
}> => {
  const res = await axios.get<{ count: number; rows: ViewAmostraAtual[] }>(
    '/amostras_utinga/acompanhamento',
    {
      params: queryDto,
    },
  );
  return res.data;
};

const alteraSemEnsaio = async (
  amostraId: number,
  formData: AlteraSemEnsaioDto,
): Promise<AmostraUtinga> => {
  const res = await axios.patch<AmostraUtinga>(
    `/amostras_utinga/${amostraId}/alterar_sem_ensaio`,
    formData,
  );
  return res.data;
};

export default {
  cria,
  criaSimples,
  listaProducao,
  listaAcompanhamento,
  alteraSemEnsaio,
};
